const items = [
  "Emergency Management Leadership",
  "Higher Education Emergency Management",
  "Public Safety & Law Enforcement",
  "Homeland Security Doctorate",
  "Kismet Leads, LLC",
  "Continuity & Resilience Programs",
];

export default function Authority() {
  return (
    <section data-testid="authority-strip" className="relative border-y border-[#262626] bg-[#0a0a0a]">
      <div className="overflow-hidden py-6">
        <div className="marquee-track">
          {[...items, ...items].map((t, i) => (
            <div key={i} className="flex items-center gap-10 px-10 whitespace-nowrap">
              <span className="text-white/70 font-display font-medium text-xl tracking-tight">{t}</span>
              <span className="text-[#d92d20] font-mono text-xs">◆</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
